import {
    FETCH_SCREEN_HOME,
    FETCH_SCREEN_DONOR_PROFILE,
    FETCH_SCREEN_FAILED
} from '../actions/types';

const INITIAL_STATE = {
    home: null,
    donorprofile: {
        favourites: [],
        donations: false
    },
    error: '',
    loading: false
};

export default function(state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_SCREEN_HOME:
            return { ...state, home: action.payload };
        case FETCH_SCREEN_DONOR_PROFILE:
            return { ...state, donorprofile: action.payload };
        case FETCH_SCREEN_FAILED:
            return { ...state, error: '', loading: false };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/screensReducer.js